import {
    SET_BREADCRUMB_ITEMS
} from './actionTypes';

interface BreadcrumbItem {
  title: string;
  link: string;
}

interface BreadcrumbState {
  title: string;
  breadcrumbItems: BreadcrumbItem[];
}

interface BreadcrumbAction {
  type: string;
  payload?: {
    title: string;
    items: BreadcrumbItem[];
  };
}

const initialState: BreadcrumbState = {
    title : "Dashboard",
    breadcrumbItems : [
        { title : "Lexa", link : "#" },
        { title : "Dashboard", link : "#" },
        { title : "Dashboard", link : "#" },
    ],
}

const layout = (state: BreadcrumbState = initialState, action: BreadcrumbAction): BreadcrumbState => {
    switch(action.type){
        case SET_BREADCRUMB_ITEMS:
            if (action.payload) {
              return {
                ...state,
                title: action.payload.title,
                breadcrumbItems: action.payload.items
              };
            }
            return state;

        default:
            state = {...state};
            break;
    }
    return state;
}

export default layout;